export default class Question {
  constructor(question) {
    this.type = question.type
    this.id = question.id
    this.prompt = question.prompt
    this.answers = question.answers
    this.unitId = question.unit_id
    this.topicId = question.topic_id
    this.categoryId = question.category_id
    this.startTime = new Date()
    this.rationale = question.rationale
    this.promptImageUrl = question.prompt_image_url
  }
}
